// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:985px){.size[data-v-4849f1fa]{height:24px;width:24px}}@media(min-width:986px){.size[data-v-4849f1fa]{height:32px;width:32px}}.order[data-v-4849f1fa]{background-color:#fff;border:1px solid #868e96;border-radius:99px;display:flex;justify-content:center;padding:2px 3px}.order>span[data-v-4849f1fa]{height:100%;text-align:center;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
